import * as types from "./types";

// Generic helpers
export const apiSuccess = (type: string, data: any) => ({
  type: types.API_SUCCESS,
  payload: { type, data },
});

export const apiFailure = (type: string, error: any) => ({
  type: types.API_FAILURE,
  payload: { type, error },
});

// Reminder actions
export const createReminder = (payload: any) => ({
  type: types.CREATE_REMINDER,
  payload,
});

export const fetchReminders = (payload: any) => ({
  type: types.FETCH_REMINDERS,
  payload,
});

export const fetchReminderById = (id: string) => ({
  type: types.FETCH_REMINDER_BY_ID,
  id,
});

export const updateReminder = (id: string, payload: any) => ({
  type: types.UPDATE_REMINDER,
  id,
  payload,
});

export const deleteReminder = (id: string) => ({
  type: types.DELETE_REMINDER,
  id,
});

export const completeReminder = (payload: any) => ({
  type: types.COMPLETE_REMINDER,
  payload,
});

export const snoozeReminder = (payload: any) => ({
  type: types.SNOOZE_REMINDER,
  payload,
});

export const fetchReminderCalendar = (payload: any) => ({
  type: types.FETCH_REMINDER_CALENDAR,
  payload,
});

export const fetchReminderQueue = (payload?: any) => ({
  type: types.FETCH_REMINDER_QUEUE,
  payload,
});

export const fetchReminderLogs = (id: string) => ({
  type: types.FETCH_REMINDER_LOGS,
  id,
});

export const exportReminders = (payload: any) => ({
  type: types.EXPORT_REMINDERS,
  payload,
});
